import { StyleSheet } from "react-native";
import { height, horizontalSize } from "../../../functions/responsive";
import { THEME_COLORS } from "../../../theme/constants/themeColors";

export default StyleSheet.create({
	container: {
		backgroundColor: THEME_COLORS.bgColor,
		justifyContent: "center",
		alignItems: "center",
		width: horizontalSize(100),
		height: height(100)
	},
	img: {
		height: "100%",
		width: "65%",
		maxWidth: 400,
		margin: 20,
	},
});
